var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.pages)?_c('div',_vm._l((_vm.pages),function(p,i){return _c('v-btn',{key:i,attrs:{"block":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.goToCustomPage(p)}}},[_vm._v(" "+_vm._s(p.name))])}),1):_c('div',[_vm._v(" NO Custom Work, Contact your account manager ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }